import { CSSProperties } from "react";

export interface Styles {
  heading: CSSProperties;
  subtitle: CSSProperties;
  label: CSSProperties;
  helper: CSSProperties;
  segmented: CSSProperties;
  segment: CSSProperties;
  segmentActive: CSSProperties;
  imagePreview: CSSProperties;
  productList: CSSProperties;
  productRowSelected: CSSProperties;
  productThumb: CSSProperties;
  productName: CSSProperties;
  productPrice: CSSProperties;
}

const styles: Styles = {
  heading: {
    fontFamily: "var(--primary-font-semibold)",
    fontSize: 16,
    color: "#1A1B22",
  },
  subtitle: {
    fontSize: 12,
    color: "#6b7280",
  },
  label: {
    fontFamily: "var(--primary-font-semibold)",
    fontSize: 13,
    color: "#1A1B22",
  },
  helper: {
    fontSize: 11,
    color: "#6b7280",
  },
  segmented: {
    backgroundColor: "#F3F4F6",
    border: "1px solid #e5e7eb",
  },
  segment: {
    fontSize: 12,
    color: "#4b5563",
    border: "none",
    background: "transparent",
  },
  segmentActive: {
    fontSize: 12,
    color: "#1A1B22",
    border: "none",
    backgroundColor: "#ffffff",
    boxShadow: "0 1px 2px rgba(0, 0, 0, 0.08)",
  },
  // Carousel banners are 16:5
  imagePreview: {
    width: 240,
    aspectRatio: "16 / 5",
    objectFit: "cover",
  },
  productList: {
    maxHeight: 260,
    overflowY: "auto",
  },
  productRowSelected: {
    backgroundColor: "#f3f7ff",
  },
  productThumb: {
    width: 32,
    height: 32,
    objectFit: "cover",
  },
  productName: {
    fontSize: 13,
    color: "#1A1B22",
  },
  productPrice: {
    fontSize: 12,
    color: "#6b7280",
  },
};

export default styles;
